import { Component, AfterViewInit } from '@angular/core';
import * as jQuery from 'jquery';
import { AnalyticsDataModel } from '../../analytics/models/analytics.datamodel';

@Component({
	selector: 'app-welcome-user',
	styleUrls: ['./welcome-user.component.css'],
	templateUrl: './welcome-user.component.html'
})
export class WelcomeUserComponent implements AfterViewInit {
	public showBanner: boolean;
	public welcomMsg: string;

	constructor(protected analyticsDataModel: AnalyticsDataModel) {
		this.showBanner = false;
		setTimeout(() => {
			if (this.showBanner) {
				this.showBanner = false;
				jQuery('div.widgets.analytics-portlet-101p').css({
					cssText: 'margin: 8px !important'
				});
			}
		}, 17000);
	}

	ngAfterViewInit(): void {
		this.welcomMsg = `Welcome to the Dashboard, ${this.analyticsDataModel.user.firstName} ${this.analyticsDataModel.user.lastName}!`;
		setTimeout(() => {
			if (!this.showBanner) {
				this.showBanner = true;
			}
		}, 2000);
	}
}
